export default __webpack_public_path__ + "a7ca6fe441148c94326d4afe3e2f09b8.svg";